import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Modal } from 'flowbite';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-edit-comment',
  templateUrl: './modal-edit-comment.component.html',
  styleUrl: './modal-edit-comment.component.scss',
  standalone: false,
})
export class ModalEditCommentComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() set commentText(value: string | undefined | null) {
    this.comment = value ?? '';
  }
  @Output() action = new EventEmitter<string>();

  public images = images;
  public comment: string = '';

  constructor(public literalService: LiteralService) {}
}
